/** Web Push helper for the Intelligent Alerts Engine (VAPID). */
import api from "@/lib/api";

const b64ToUint8 = (b64) => { const pad = "=".repeat((4 - (b64.length % 4)) % 4); const raw = atob((b64 + pad).replace(/-/g, "+").replace(/_/g, "/")); return Uint8Array.from([...raw].map((c) => c.charCodeAt(0))); };

export const pushSupported = () => typeof window !== "undefined" && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export async function pushStatus() {
  if (!pushSupported()) return { supported: false, permission: "unsupported", subscribed: false };
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = reg ? await reg.pushManager.getSubscription() : null;
  return { supported: true, permission: Notification.permission, subscribed: !!sub, endpoint: sub?.endpoint };
}

export async function enablePush() {
  if (!pushSupported()) throw new Error("This browser does not support push notifications");
  const { data } = await api.get("/alerts/push/public-key");
  if (!data.public_key) throw new Error("Push is not configured on the server");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Notification permission was not granted");
  const reg = (await navigator.serviceWorker.getRegistration()) || (await navigator.serviceWorker.register("/sw.js"));
  await navigator.serviceWorker.ready;
  const sub = (await reg.pushManager.getSubscription()) || (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToUint8(data.public_key) }));
  await api.post("/alerts/push/subscribe", { subscription: sub.toJSON(), user_agent: navigator.userAgent });
  return sub;
}

export async function disablePush() {
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = reg ? await reg.pushManager.getSubscription() : null;
  if (sub) { await api.delete("/alerts/push/subscribe", { params: { endpoint: sub.endpoint } }); await sub.unsubscribe(); }
}
